export default __webpack_public_path__ + "static/media/LU.f3a8539d.svg";